import * as React from "react";
import { maxHscMembers } from "../../../consts/consts";
import Alert from "../../Alert";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import {priceToNumber} from "../CRUDProperty";

const PropertyPayments = ({paymentsData, propertyData, handleChangeDropdown, handleChangeInput, viewMode, deleted, handleAddMember, isReferral, isHsc}) => {
    const theme = 'white';
    const decimals = 2;
    const percentageDecimals = 2;
    const feeAmount = isHsc ? propertyData.HSC_LIST_FEE : isReferral ? propertyData.REFERRAL_FEE : propertyData.POTENTIAL_FEE;
    const grossFeeKey = isHsc ? 'HSC_TEAM_MEMBER_GROSS_FEE':'STRIVE_TEAM_MEMBER_GROSS_FEE'
    const netFeeKey = isHsc ? 'HSC_TEAM_MEMBER_NET_FEE':'STRIVE_TEAM_MEMBER_NET_FEE'

    
    
    if(isHsc)
        paymentsData = new Array(maxHscMembers).fill(null).map((el, index) => {return {
                HSC_TEAM_MEMBER_ID:propertyData[`HSC_TEAM_MEMBER_${index+1}`],
                HSC_TEAM_MEMBER_PERCENT:propertyData[`HSC_TEAM_MEMBER_${index+1}_PERCENT`],
                HSC_TEAM_MEMBER_NET_FEE:propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_FEE`] ? propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_FEE`].toLocaleString() : null,
                HSC_TEAM_MEMBER_NET_PERCENT:propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_PERCENT`],
                HSC_TEAM_MEMBER_GROSS_FEE:propertyData[`HSC_TEAM_MEMBER_${index+1}_GROSS_FEE`] ? propertyData[`HSC_TEAM_MEMBER_${index+1}_GROSS_FEE`].toLocaleString() : null
            }
        });

    function computeTotalGross() {
        if (!paymentsData)
            return null;
        let sum = 0;
        paymentsData.forEach(elem => sum += elem[grossFeeKey] ? priceToNumber(elem[grossFeeKey]) : 0);
        return sum.toFixed(decimals);
    }

    function computeTotalNet() {
        if (!paymentsData)
            return null;
        let sum = 0;
        paymentsData.forEach(elem => sum += elem[netFeeKey] ? priceToNumber(elem[netFeeKey]) : 0);
        return sum.toFixed(decimals);
    }

    function totalGrossIsStriveFee() {

        if (!feeAmount && !(parseFloat(computeTotalGross()))) {
            return true;
        }

        return feeAmount && computeTotalGross() === Number(feeAmount.replace(',', '')).toFixed(decimals);
    }

    return (
        <React.Fragment>
            <div className="Property-payments_actions">
                <Input
                    className="Property-payments_column_item"
                    type="text"
                    valueType="float"
                    name={isHsc ? "HSC_LIST_FEE" : isReferral ? "REFERRAL_FEE" : "POTENTIAL_FEE"}
                    label={isHsc ? "HSC Fee":"SUMMIT Fee"}
                    value={feeAmount}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                    disabled
                    decimals={decimals}
                />
                {
                    !totalGrossIsStriveFee() &&
                    <Alert type='error'> Total Gross Commission does not equal {isHsc ? 'HSC': 'Summit'} Fee </Alert>
                }
            </div>
            <div className={`Property-payments ${isHsc?'HSC':''}`}>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            isHsc ? 
                            <Dropdown
                                optionsType='team-members'
                                optionLabelKey='NAME'
                                optionKey={"EMAIL"}
                                key={`${index}-TEAM`}
                                className="Property-payments_column_item"
                                valueKey={`HSC_TEAM_MEMBER_ID`}
                                percentKey={`HSC_TEAM_MEMBER_PERCENT`}
                                isFromProperty
                                value={data.HSC_TEAM_MEMBER_ID}
                                label={`PEAK Team Member ${index + 1}`}
                                percentLabel='Member %'
                                data={paymentsData[index]}
                                hasAgentPercent={true}
                                handleParentChange={(data, optionsType, reason, key) => {
                                    handleChangeDropdown({index, data, key})
                                }}
                                handleInputParentChange={(key, value) =>
                                    handleChangeInput({index, key, value})
                                }
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                            :
                            <SelectTeam
                                key={`${index}-TEAM`}
                                className="Property-payments_column_item"
                                valueKey='STRIVE_TEAM_MEMBER_ID'
                                percentKey='STRIVE_TEAM_MEMBER_PERCENT'
                                isFromProperty
                                value={data.STRIVE_TEAM_MEMBER_ID}
                                label={`Summit Team Member ${index + 1}`}
                                percentLabel='Member %'
                                data={paymentsData[index]}
                                hasAgentPercent={true}
                                handleParentChange={(data, optionsType, reason, key) => {
                                    handleChangeDropdown({index, data, key})
                                }}
                                handleInputParentChange={(key, value) =>
                                    handleChangeInput({index, key, value})
                                }
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                        ))
                    }
                    {
                        !viewMode && !isHsc &&
                        <button
                            type="button"
                            className="button-new positive add-member-button"
                            onClick={handleAddMember}>
                            Add member
                        </button>
                    }
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                className="Property-payments_column_item"
                                key={`${index}-${grossFeeKey}`}
                                theme={theme}
                                type="text"
                                valueType="float"
                                label='Gross Commission'
                                value={data[grossFeeKey]}
                                disabled
                                isDollar
                                viewMode={viewMode}
                                decimals={decimals}
                            />
                        ))
                    }
                    <Input
                        className="Property-payments_column_item"
                        type="text"
                        valueType="float"
                        label="Total Gross Commission"
                        value={computeTotalGross()}
                        isDollar
                        disabled
                        viewMode={viewMode}
                        decimals={decimals}
                    />
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                className="Property-payments_column_item"
                                key={`${index}-${netFeeKey}`}
                                theme={theme}
                                type="text"
                                valueType="float"
                                label='Net Commission'
                                value={data[netFeeKey]}
                                disabled
                                isDollar
                                viewMode={viewMode}
                                decimals={decimals}
                            />
                        ))
                    }
                    <Input
                        className="Property-payments_column_item"
                        type="text"
                        valueType="float"
                        label="Total Net Commission"
                        value={computeTotalNet()}
                        isDollar
                        disabled
                        viewMode={viewMode}
                        decimals={decimals}
                    />
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                key={`${index}-PERCENTAGE`}
                                className='Property-payments_column_item'
                                type='text'
                                valueType='percent'
                                label='%'
                                value={isHsc ? data.HSC_TEAM_MEMBER_NET_PERCENT : data.STRIVE_TEAM_MEMBER_NET_PERCENT || ''}
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled
                                decimals={percentageDecimals}
                            />
                        ))
                    }
                </div>
                { !isHsc &&
                    <div className="Property-payments_column">
                        {
                            paymentsData && paymentsData.map((data, index) => {
                                if(!viewMode && data.STRIVE_TEAM_MEMBER_ID)
                                    return(
                                        <div className="Property-payments_column_item">
                                            <button key={`${index}-REMOVE`} type='button' className='button-new negative' 
                                            onClick={()=>handleChangeInput({key:'DELETED',value:'1',index})}>Remove</button>
                                        </div>
                                    )
                            })
                        }
                    </div>
                }
            </div>
        </React.Fragment>
    );
};

export default PropertyPayments;
